import { Step, StepId, TypedStep } from "@redotech/redo-return-ui/flows/step";

export function updateStepConnection(
  step: Step,
  handleIndex: number,
  targetStepId: StepId,
): Step {
  if (!step.type.updateConnection) {
    return step;
  }
  const maxDownstream = step.maxDownstream();

  if (handleIndex >= maxDownstream) {
    throw new Error(
      `Cannot add connection at index ${handleIndex}. Max downstream is ${maxDownstream}`,
    );
  }

  const newState = step.type.updateConnection(
    step.state,
    handleIndex,
    targetStepId,
  );
  return new TypedStep((step as TypedStep<any, any>).type, newState);
}

export function removeStepConnection(step: Step, targetStepId: StepId): Step {
  if (!step.type.removeConnection) {
    return step;
  }
  const newState = step.type.removeConnection(step.state, targetStepId);
  return new TypedStep((step as TypedStep<any, any>).type, newState);
}
